import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "py-8 lg:py-16 xl:py-32 max-w-container px-container" }
const _hoisted_2 = {
  key: 0,
  class: "\n          grid grid-cols-1\n          sm:grid-cols-1\n          md:grid-cols-2\n          lg:grid-cols-3\n          gap-y-14 gap-x-7\n        "
}
const _hoisted_3 = {
  key: 1,
  class: "\n          grid grid-cols-1\n          sm:grid-cols-1\n          md:grid-cols-2\n          lg:grid-cols-3\n          gap-y-14 gap-x-7\n        "
}
const _hoisted_4 = { class: "text-center md:text-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PageTitle = _resolveComponent("PageTitle")
  const _component_PostCardSkeleton = _resolveComponent("PostCardSkeleton")
  const _component_PostCard = _resolveComponent("PostCard")
  const _component_ArrowIcon = _resolveComponent("ArrowIcon")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_PageTitle, { class: "mb-10 text-amff-teal" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t("post.lastest_news")), 1)
      ]),
      _: 1
    }),
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in",
      class: "mb-16"
    }, {
      default: _withCtx(() => [
        (_ctx.isFetching)
          ? (_openBlock(), _createBlock("ul", _hoisted_2, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.limit, (index) => {
                return (_openBlock(), _createBlock("li", {
                  key: 'post' + index
                }, [
                  _createVNode(_component_PostCardSkeleton)
                ]))
              }), 128))
            ]))
          : (!_ctx.isFetching && _ctx.posts?.length)
            ? (_openBlock(), _createBlock("ul", _hoisted_3, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.posts, (post) => {
                  return (_openBlock(), _createBlock("li", {
                    key: 'post' + post.id
                  }, [
                    _createVNode(_component_PostCard, { post: post }, null, 8, ["post"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        as: _ctx.AnchorLink,
        to: { name: 'news' },
        color: "amff-teal-outline",
        class: "mb-10 mr-0 md:mr-10"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("post.see_latest_news")) + " ", 1),
          _createVNode(_component_ArrowIcon, {
            fill: "currentColor",
            class: "ml-2 w-6 h-6"
          })
        ]),
        _: 1
      }, 8, ["as"])
    ])
  ]))
}